import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserMessagesPageComponent } from './features/user-messages-page/user-messages-page.component';
import { AppPageComponent } from '../../../lib/ui/app/app-page/app-page.component';
import { AppBarComponent } from '../../../lib/ui/app/app-bar/app-bar.component';
import { AppBarTitleComponent } from '../../../lib/ui/app/app-bar-title/app-bar-title.component';
import { AppBarContactComponent } from '../../../lib/ui/app/app-bar-contact/app-bar-contact.component';
import { UserMessagesCanDeactivateGuard } from './infrastructure/user-messages-can-deactivate.guard';

const routes: Routes = [
  {
    path: 'messages',
    component: AppPageComponent,
    data: {
      appPage: {
        contentClass: 'simple',
        contentAlignment: 'center-start',
        contentWithoutPadding: true
      },
      appBar: {
        logoHidden: false,
        stickyDisabled: true,
      }
    },
    children: [
      {
        path: '',
        outlet: 'app-bar',
        component: AppBarComponent,
        children: [
          {
            path: '',
            outlet: 'title',
            component: AppBarTitleComponent,
          },
          {
            path: '',
            outlet: 'right',
            component: AppBarContactComponent,
          }
        ]
      },
      {
        path: '',
        component: UserMessagesPageComponent,
        canDeactivate: [UserMessagesCanDeactivateGuard]
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserMessagesRoutingModule {}
